/*
 * Generated Util JS
 * Contents: adjustcols.js ajaxcache.js bind.js cookies.js debounce.js eventmanager.js header.js identifycurrentlink.js legacy.js load.js overflow.js prop.js query.js scrollanimation.js speciallinks.js svgfit.js tel.js truncate.js urls.js 
 */

var ZOL = ZOL || {}; // Global FVD namespace.
ZOL.util = ZOL.util || {}; // Utility function namespace.
ZOL.util.options = ZOL.util.options || {}; // Storage for utility options.

(function() {
/**
 * Returns a function that, when called repeatedly, will not call the underlying callback until a given amount of time has passed.
 * https://davidwalsh.name/javascript-debounce-function
 * @param func The callback to call after the time has passed.  Provided all arguments given to the returned debounce function.
 * @param wait The amount of milliseconds to wait before the function is called.
 * @param immediate Set to true to call the function on first call of debounce, and wait 'wait' milliseconds before being able to trigger again.
 * @return A debounce-wrapped version of the provided function that may be called repeatedly.  All arguments passed to the inner debounce.
 */
ZOL.util.debounce = function(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callnow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callnow) func.apply(context, args);
	};
};
})();

(function() {
/**
 * Iterates over elements in a set and will adjusting the height of all elements that
 * start at the same Y position to the height of the tallest element at that Y position.
 * @param selector The selector of elements to change sizing of. Child-level elemtns that would normally have a col-*-*
 */
ZOL.util.adjustColHeights = function(selector) {

	var deb = ZOL.util.debounce(adjustHeights, 500, false); // Store debounce reference.
	$(window).on('resize', function() { // Run on resize.
		deb(selector);
	});
	deb(selector); // Run once immediately.

	function adjustHeights() {
		var offset = 0;
		var maxheight = 0;
		var neighbours = [];
		var i;

		$(selector).css('height', ''); // Remove any existing heights.
		$(selector).each(function() { // Then check every element in sequence.

			if ($(this).offset().top == offset) { // If at the current offset, this element is part of the same group.

				neighbours.push($(this));

				if ($(this).height() > maxheight) { // This element is taller.
					maxheight = $(this).height();
				}
			} else { // We are in a new row.
				for(i = 0; i < neighbours.length; i += 1) { // Elements in the previous row should expand to the tallest.
					$(neighbours[i]).height(maxheight);
				}
				offset = $(this).offset().top; // Start a new row by storing the offset.
				maxheight = $(this).height(); // Start with a new maxheight.
				neighbours = [$(this)]; // Start new neighbour list with the current element.
			}
		});
	}
};
})();

(function() {
var requestpool = {}; // Storage for pooled API data calls, so multiple requests get the same promise.
ZOL.util.options['ajax_default_expiration_time'] = 900; // Default time, in seconds, to cache ajax requests for (900 = 15 minutes).

/**
 * Generates a simple hash of a string.
 * @param str The string to hash.
 * @returns The integer hash value of this request.
 */
function hashString(str) {
	var hash = 0;
	var i = 0;
	var len = str.length;
	while (i < len) {
		hash = ((hash << 5) - hash + str.charCodeAt(i++)) << 0;
	}
	return 'util.ajax.' + hash;
}

function standardAjax(data, hash) {
	if (data.cache && requestpool[hash]) { // If we allow caching, and have a cached copy, return that copy instead..
		return requestpool[hash];
	}
	return $.ajax(data); // Otherwise, return a new request.
}

function getLocalData(data, hash) {
	var result = localStorage.getItem(hash);
	if (data.dataType == 'json') { // We're expecting JSON, so try to parse the data as json, and fall back to the original data on error.
		try { result = JSON.parse(result); }
		catch (err) { }
	}
	return result;
}

function getAjaxData(dataRequest, hash, expiration) {
	var deferred = $.ajax(dataRequest); // Make our request.
	var nowrite = false;

	// Set expiration time in local storage.
	try {
		localStorage.setItem(hash + '_expiration', expiration);
	} catch (err) {
		nowrite = true;
	}

	// When the request is done, the first thing we should do is store the resulting data in local storage.
	deferred.done(function (data) {

		if (dataRequest.dataType == 'json') { // Ensure we stringify any json data first, before storing.
			data = JSON.stringify(data);
		}

		if (!nowrite) {
			try {
				localStorage.setItem(hash, data); // Store in local storage.
			} catch (err) { // Couldn't store item, but expiration was stored, remove the expiration
				localStorage.removeItem(hash + '_expiration');
			}
		}
	});

	// Any additional data use will happen after being stored locally
	return deferred;
}

/**
 * Uses a formatted request object in order to make an AJAX request, pulling data from local storage if possible.
 * Multiple calls with the same configuration will receive the same promise and resulting data.
 *
 * @param requestdata jQuery formatted AJAX request object, used to determine if multiple requests are the same.
 * @param extradata Additional values to add to the request data's `data` parameter, but not to use in determining if a request is the same.
 * @param expiration An expiration time for data when stored in localstorage, in seconds.
 * @returns A promise that will return the data.
 */
ZOL.util.ajax = function (requestdata, extradata, expiration) {

	// Normalize the AJAX request options.
	requestdata.method = requestdata.method || 'get';
	requestdata.method = requestdata.method.toLowerCase();
	requestdata.dataType = requestdata.dataType || 'text';
	requestdata.dataType = requestdata.dataType.toLowerCase();
	requestdata.cache = typeof requestdata.cache == undefined ? requestdata.cache : true; // Defaults to true.

	// Set a default expiration time.
	expiration = Math.floor((Date.now() / 1000) + (expiration || ZOL.util.options['ajax_default_expiration_time'])); // Apply default time before re-grabbing data, if none is provided.

	// Generate the hash for the request, without the extra data.
	var datahash = hashString(JSON.stringify(requestdata));

	// Add extra data properties to the request data.
	if (extradata) {
		requestdata.data = requestdata.data || {};
		$.extend(requestdata.data, extradata);
	}

	// If local storage is not enabled, run a standard ajax request.
	if (!window.localStorage || !window.sessionStorage || !localStorage) {
		return standardAjax(requestdata, datahash);
	}

	// If local storage is supported but quota is 0 (Private mode safari).
	// https://www.reddit.com/r/javascript/comments/2z06aq/local_storage_is_not_supported_with_safari_in/
	try {
		localStorage.setItem('localStorageTest', '1');
		localStorage.removeItem('localStorageTest');
	} catch (err) {
		return standardAjax(requestdata, datahash);
	}

	// Check if the item in storage is expired, and unset the local storage (and the short term cache just in case).
	if (Math.floor((Date.now() / 1000)) > localStorage.getItem(datahash + '_expiration')) {
		localStorage.removeItem(datahash);
		requestpool[datahash] = null;
	}

	// If we are allowing data cache, check the short term request cache.
	if (requestdata.cache && requestpool[datahash]) {
		return requestpool[datahash];
	}

	var deferred; // The deferred object backing the promise this function returns.

	if (localStorage.getItem(datahash)) { // If this is already exists in the local storage, retrieve the data.
				
		deferred = $.Deferred();
		deferred.resolve(getLocalData(requestdata, datahash));
		deferred = deferred.promise();
	} else { // Otherwise make a new ajax request
		deferred = getAjaxData(requestdata, datahash, expiration);
	}

	if (requestdata.cache) { // If we should cache the data, store the request in our request pool.
		requestpool[datahash] = deferred;
	}

	return deferred;
};
})();

(function() {
/**
 * Finds elements that have a class beginning with a specific pattern and calls their underlying controllers.
 * @param selector The elements to perform binds on.
 * @param prefix The prefix used when parsing for the controller name.
 * @param The set of controllers to search through.
 */
ZOL.util.initializeBinds = function(selector, prefix, controllers) {
	var reg = new RegExp('(?:^|\\s)' + prefix + '(\\S+)')
	$(selector).each(function() {
		var results;
		var controller;
		var classes = $(this).attr('class');
		if (classes) {
			results = classes.match(reg);
			if (results != null) {
				controller = controllers[results[1]];
				if (typeof controller !== 'undefined') {
					controller($(this));
				}
			}
		}
	});
};
})();

(function() {
/**
 * Sets a cookie.
 * @param name The name of the cookie.
 * @param value The value to store.
 * @param seconds The optional number of seconds to store the cookie for.
 */
ZOL.util.setCookie = function(name, value, seconds) {
	var expires = '';
	var date;
	if (seconds) {
		date = new Date();
		date.setTime(date.getTime() + (seconds * 1000));
		expires = '; expires=' + date.toGMTString();
	}
	document.cookie = name + '=' + value + expires + '; path=/';
};

/**
 * Retrieves the value associated with a cookie.
 * @param name The name of the cookie.
 * @returns The value, or null if the cookie does not exist or has expired.
 */
ZOL.util.getCookie = function(name) {
	var i;
	var start;
	var parts = document.cookie.split(';');
	for(i = 0; i < parts.length; i += 1) {
		start = 0;
		while (parts[i].charAt(start) == ' ') {
			start += 1;
		}
		parts[i].substring(start);
		if (parts[i].indexOf(name + '=') == start) {
			return parts[i].substring(start + name.length + 1);
		}
	}
	return null;
};
})();

(function() {
/**
 * Creates an EventManager that that allows for callback registering and dispatching.
 * @return A new EventManager.
 */
ZOL.util.EventManager = function() {
	var self = {};

	self.callbacks = []; // All stored callbacks thus far.

	/**
	 * Calls all callbacks with all provided arguments.
	 * @param ... Variable arguments passed to inner function.
	 * @return An array of all results from the inner callbacks.
	 */
	self.dispatch = function() {
		var i;
		var results = [];
		for (i = 0; i < self.callbacks.length; i += 1) {
			results.push(self.callbacks[i].apply(self.callbacks[i], arguments));
		}
		return results;
	};

	/**
	 * Registers a new callback with the manager.
	 * @param callback The function to call when the manager dispatches an event.
	 */
	self.register = function(callback) {
		var index = self.callbacks.indexOf(callback);
		if (index == -1) {
			self.callbacks.push(callback);
		}
	};

	/**
	 * Removes a callback from the manager.
	 * @param callback The function to remove from this manager.
	 */
	self.deregister = function(callback) {
		var index = self.callbacks.indexOf(callback);
		if (index != -1) {
			self.callbacks = self.callbacks.splice(index, 1);
		}
	};

	return self;
}
})();

(function() {
/**
 * Checks links against the current URL and applies a class if there's a match
 * @param selector The selector for <a> elements to check
 * @param className The class to apply
 */
ZOL.util.identifyCurrentLink = function(selector, className) {
	$(selector).each(function() {
		var link = $(this).attr('href');
		if (link === window.location.href || link === window.location.pathname) {
			$(this).addClass(className);
		}
	});
}
})();

(function() {
/**
 * Adds classes to the html element depending on the user-agent of the browser,
 * for the purpose of helping in mitigating issues of old/terrible browsers.
 */
$(document).ready(function() {

	// Selector code provided by https://github.com/rodneyrehm/viewport-units-buggyfill
	// Uses same concept as viewport-units-buggyfill, but instead of a full JS implementation we just add on classes like modernizr.

	var useragent = window.navigator.userAgent;

	var isWindows = function() {
		return window.navigator.platform.indexOf('Win') == 0;
	}

	var isMobileSafari = function() {
		var version;
		if (useragent.match(/(iPhone|iPod|iPad).+AppleWebKit/i)) {
			return false;
		}
		// Regexp for iOS-version tested against the following userAgent strings:
		// Example WebView UserAgents:
		// * iOS Chrome on iOS8: "Mozilla/5.0 (iPad; CPU OS 8_1 like Mac OS X) AppleWebKit/600.1.4 (KHTML, like Gecko) CriOS/39.0.2171.50 Mobile/12B410 Safari/600.1.4"
		// * iOS Facebook on iOS7: "Mozilla/5.0 (iPhone; CPU iPhone OS 7_1_1 like Mac OS X) AppleWebKit/537.51.2 (KHTML, like Gecko) Mobile/11D201 [FBAN/FBIOS;FBAV/12.1.0.24.20; FBBV/3214247; FBDV/iPhone6,1;FBMD/iPhone; FBSN/iPhone OS;FBSV/7.1.1; FBSS/2; FBCR/AT&T;FBID/phone;FBLC/en_US;FBOP/5]"
		// Example Safari UserAgents:
		// * Safari iOS8: "Mozilla/5.0 (iPhone; CPU iPhone OS 8_0 like Mac OS X) AppleWebKit/600.1.3 (KHTML, like Gecko) Version/8.0 Mobile/12A4345d Safari/600.1.4"
		// * Safari iOS7: "Mozilla/5.0 (iPhone; CPU iPhone OS 7_0 like Mac OS X) AppleWebKit/537.51.1 (KHTML, like Gecko) Version/7.0 Mobile/11A4449d Safari/9537.53"

		// Viewport units work fine in mobile Safari and webView on iOS 8+.
		version = useragent.match(/OS (\d)/);
		return (!!version) && parseInt(version[1]) < 8;
	};

	var isBadStockAndroid = function() {
		var version;
		// Android stock browser test derived from
		// http://stackoverflow.com/questions/24926221/distinguish-android-chrome-from-stock-browser-stock-browsers-user-agent-contai
		if (useragent.indexOf(' Android ') == -1) { // Not Android at all.
			return false;
		}

		if (useragent.indexOf('Version/') == -1) { // Not stock Android.
			return false;
		}

		// Anything below 4.4 uses WebKit without *any* viewport support, and 4.4 has issues with viewport units within calc().
		version = useragent.match('Android (\d+.\d+)');
		return (!!version) && parseFloat(version[1]) <= 4.4;
	};

	if(isBadStockAndroid()) {
		$('html').addClass('legacy-view-units legacy-android no-calc');
	}

	if (isMobileSafari()) {
		$('html').addClass('legacy-view-units legacy-safari');
	}

	if (isWindows()) {
		$('html').addClass('os-win');
	}
});
})();

(function() {
/**
 * Checks to see if a JS file is already loaded, loading the file if it isn't, and executing optional callbacks.
 * @param filepath The javascript source location.
 * @param callback The callback to execute once a script is loaded.
 */
ZOL.util.loadJS = function(filepath, callback) {
	
	if (typeof callback == 'undefined') {
		callback = function() { };
	}

	var script = $('script[src="' + filepath + '"]');
	if (!script.length) { // Script not added to the document.
		script = document.createElement('script');
		$('head').append(script);
		script.type = 'text/javascript';
		$(script).on('load', function() {
			$(script).data('loaded', true);
			callback();
		});
		script.src = filepath;
	} else { // Script added, now see if it is loaded.
		if (script.data('loaded')) { // Script is loaded, call callback immediately.
			callback();
		} else { // Script not loaded, add event.
			$(script).on('load', callback);
		}
	}
};

/**
 * Checks to see if a CSS file is already loaded, loading the file if it is not.
 * @param filepath The URL or path to the CSS file to load.
 */
ZOL.util.loadCSS = function(filepath) {
	if ($('link[href="' + filepath + '"]').length < 1) { // Style not loaded.
		$('head').append('<link rel="stylesheet" type="text/css" media="all" href="' + filepath + '">');
	}
};
})();

(function() {
/**
 * Returns _direct_ child elements within the given element that are outside of its viewable area.
 * http://stackoverflow.com/questions/7668636/check-with-jquery-if-div-has-overflowing-elements
 * @param el The element to check for items within.
 * @return The number of child elements currently outside of the element's viewable area.
 */
ZOL.util.overflow = function(el) {
	var element = $(el).get(0);
	var i;
	var child;
	var clipped = [];
	for (i = 0; i < element.children.length; i += 1) {
		child = element.children[i];
		if (child.offsetTop + child.offsetHeight > element.offsetTop + element.offsetHeight
			|| child.offsetLeft + child.offsetWidth > element.offsetLeft + element.offsetWidth) {
			clipped.push(child);
		}
	}
	return clipped;
};
})();

(function() {
/**
 * Internal function creates anchor tags for use in the parsing of URL parts.
 * @param url The URL to create the anchor tag for.
 */
function makeAnchor(url) {
	var anchor = document.createElement('a'); // Create a raw anchor element to use as a simple URL parser.
	anchor.href = url;
	if (anchor.host == '') { // For IE, as the rest of the properties don't end up being set unless the href is forced again.
		anchor.href = anchor.href;
	}
	return anchor;
}

/**
 * Retrieves the protocol from the URL provided.
 * @param url The URL to parse.
 */
ZOL.util.getProtocol = function(url) {
	return makeAnchor(url).protocol;
};

/**
 * Retrieves the host name and port from the URL provided.
 * @param url The URL to parse.
 */
ZOL.util.getHost = function(url) {
	return makeAnchor(url).hostname;
};

/**
 * Retrieves the path from the URL provided.
 * @param url The URL to parse.
 */
ZOL.util.getPath = function(url) {
	var path = makeAnchor(url).pathname;
	if (path.indexOf('/') != 0) {
		path = '/' + path;
	}
	return path;
};

/**
 * Retrieves the hash from the URL provided.
 * @param url The URL to parse.
 */
ZOL.util.getHash = function(url) {
	return makeAnchor(url).hash;
};

/**
 * Retrieves the query string from the URL provided.
 * @param url The URL to parse.
 */
ZOL.util.getQuery = function(url) {
	return makeAnchor(url).search;
};
})();

(function() {
/**
 * Tries to retrieve a nested value for a property.
 * @param obj The object to check the properties within.
 * @param ... Any additional parameters are the elements to search through.
 * @return The specified property of the object, or undefined if not found.
 */
ZOL.util.prop = function(obj) {
	var i = 1; // Start at first argument, after object.
	while (typeof obj === 'object' && obj != null && i < arguments.length) {
		obj = obj[arguments[i]] || undefined;
		i += 1;
	}
	if (i != arguments.length) { // Didn't get to the end.
		return undefined;
	}
	return obj;
}
})();

(function() {
/**
 * Retrieves query parameters from the given url as an associative array.
 * @param url The URL to parse the query data from.
 * @returns An object with properties representing the values provided in the URL's query string.
 */
ZOL.util.getQueryData = function(url) {
	var data = {};
	var query = ZOL.util.getQuery(url);
	if (!query) {
		return data;
	}
	query = query.substring(1).split('&'); // Strips '?' from query, then splits into key-value pairs.
	for (var i = 0; i < query.length; i += 1) {
		var pair = query[i].split('=');
		if (typeof data[pair[0]] === 'undefined') { // If first entry with this name, store value as string.
			data[pair[0]] = decodeURIComponent(pair[1]);
		} else if (typeof data[pair[0]] === 'string') { // If second entry with this name, pair old and new data as array.
			var arr = [data[pair[0]], decodeURIComponent(pair[1])];
			data[pair[0]] = arr;
		} else { // If third or later entry with this name, add to existing array.
			data[pair[0]].push(decodeURIComponent(pair[1]));
		}
	}
	return data;
};
})();

(function() {
/**
 * Jquery extension that determines whether or not the top of an element is visible above the top of the scrolled viewport.
 * If an element has a property of 'data-visible-amount', the element's top must be that distance higher from the bottom of the view.
 * If the amount is followed by %, it causes the offset to instead be a percentage of the element's height.
 * If the amount is followed by vh, it causes the offset to instead be a percentage of the view's height.
 * Otherwise, if just a number, or followed by px, it is treated as a raw pixel value.
 * @this The element that is having visibility determined.
 */
$.fn.visible = function() {
	var rect = $(this)[0].getBoundingClientRect(); // Element's position and size, relative to the screen.
	var height = $(window).height(); // Total height of the window.
	var offset = $(this).data('visible-amount'); // Amount of object that should be visible before triggering.
	var distance = rect.top;
	if (typeof offset == 'number') { // Make sure raw numbers are treated as px values.
		offset = offset + 'px';
	}
	if (typeof offset == 'undefined') {
		// Nothing, keep top the same.
	} else if (offset.match(/%$/)) {
		distance -= parseInt(offset.slice(0, -1)) / 100 * rect.height;
	} else if (offset.match(/vh$/)) {
		distance -= parseInt(offset.slice(0, -2)) / 100 * height;
	} else if (offset.match(/px$/)) {
		distance -= parseInt(offset.slice(0, -2));
	} else {
		console.log('Invalid unit on: ' + offset);
	}
	return distance < height;
};

/**
 * Takes elements within the given selector that have the 'will-animate' and performs one of two actions:
 *   1) If the element is already visible, it will apply an 'animated' class to the element.
 *   2) If the element is not visible, it will apply an 'animate' class as soon as a scroll event occurs where it is visible.
 * When either of these actions occur, an 'animated' event will be triggered on the element.
 * @param selector The element to look for animatable elements within.
 */
ZOL.util.scrollAnimationBinds = function(selector) {
	var toanimate = $(selector).find('.will-animate');

	toanimate = $.grep(toanimate, function(el) { // Find elements that are already visible.
		el = $(el);
		if (el.visible()) {
			el.addClass('animated');
			el.trigger('visible');
			return false;
		} else {
			return true;
		}
	});

	$(window).scroll(function(event) { // When the window scrolls, check for newly visible elements and animate them.
		toanimate = $.grep(toanimate, function(el) {
			var el = $(el);
			if (el.visible()) {
				el.addClass('animate');
				el.trigger('visible');
				return false;
			} else {
				return true;
			}
		});
	});
};
})();

(function() {
var speciallinkmanager = new ZOL.util.EventManager(); // Event manager for special link navigation events.

/**
 * Registers a callback for the special link event.
 * @param callback The function to call when a special link is clicked.
 *   Function is provided with the portion of the special hash after the '#X:' indicator.
 */
ZOL.util.addSpecialLinkCallback = speciallinkmanager.register;

/**
 * Removes a callback applied on the special link events.
 * @param callback The function to no longer call when a special link is clicked.
 */
ZOL.util.removeSpecialLinkCallback = speciallinkmanager.deregister;

/**
 * Checks to see if a hash begins with '#X:', and if so, dispatches the appropriate event.
 * @param The relative url or hash being checked.
 * @return True if the link is a special link/hash, and the appropriate event raised, or false if not.
 */
ZOL.util.trySpecialLink = function(hash) {
	if (hash.indexOf('#X:') == 0) {
		speciallinkmanager.dispatch(hash.substring(3));
		return true;
	}
	return false;
}

function anchorTransitionHandler(e) { // Check to see if the link is a special link, and execute the appropriate functionality.
	
	var url = $(this).attr('href');
	
	// Make sure the anchor actually has a URL defined.
	if (typeof url === 'undefined'
		|| !url) {
		return;
	}
	
	if (ZOL.util.trySpecialLink(url)) { // If it is a special link, prevent the default link click behavior.
		e.preventDefault();
	}
}

// Attach handler on initial page load.
$(document).ready(function() {
	$(document).on('click', 'a', anchorTransitionHandler); // Any unsuppressed anchor click.
	ZOL.util.trySpecialLink(ZOL.util.getHash(window.location + '')); // Try handling the current hash, in case we are executing something special on initial load.
});
})();

(function() {
/**
 * Causes SVG elements to display the entire graphic within their available space, based on the shape's underlying bounding box.
 * @param selector The element to get svgs for viewbox.
 */
ZOL.util.setSVGViewBox = function(selector) {
	$(selector).each(function() {
		$(this).css('display', ''); // In case the display style hasn't been stripped beforehand.
		if (!$(this)[0].hasAttribute('viewBox')) {
			var bbox = $(this).find("path")[0].getBBox();
			$(this)[0].setAttribute('viewBox', bbox.x + ' ' + bbox.y + ' ' + bbox.width + ' ' + bbox.height);
		}
	});
};
})();

(function() {
/**
 * Searches through specified elements to find any text nodes with content resembling a telephone number, creating tel protocol links for them.
 * @param selector The selector for elements to search through.
 */
ZOL.util.applyTelephoneLinks = function(selector) {
	var phoneregex = /\s?((?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?)\s?/g;
	$(selector).contents().each(function() {
		if (this.nodeType != 3) { // Ignore all nodes that are not text.
			return;
		}
		$(this).replaceWith(this.textContent.replace(phoneregex, ' <a href="tel://$2$3$4$5$6">$1</a> '));
	});
};
})();

(function() {
/**
 * Truncates a string based on the character count, appending an ellipse if truncated.
 * http://stackoverflow.com/questions/1199352/smart-way-to-shorten-long-strings-with-javascript
 * @param str The string to truncate.
 * @param count The maximum number of characters to truncate to.
 * @param onboundary True will truncate at the last available word boundary, and false will truncate at the exact given character.
 * @return Returns the truncated string.
 */
ZOL.util.truncate = function(str, count, onboundary, append) {
	if (str.length > count) {
		str = str.substr(0, count - 1);
		if (onboundary) {
			str = str.substr(0, str.lastIndexOf(' '));
		}
		if (typeof append === 'undefined') {
			str += '&hellip;';
		} else {
			str += append;
		}
	}
	return str;
};
})();